import React, { useEffect, useRef } from 'react';
import type { CmsPageProviderCoreProps } from '@gov-nx/component/common/Cms/CmsPageProviderCore';
import { CmsPageProviderCore } from '@gov-nx/component/common/Cms/CmsPageProviderCore';
import { scrollIntoView } from '@gov-nx/web/Router/scrollUtils';
import { CmsPageSkeleton } from './CmsPageSkeleton';

export const CmsPageProvider = (props: CmsPageProviderCoreProps) => {
	const ref = useRef<{ init: () => void }>(null);
	useEffect(() => {
		if (ref.current) {
			ref.current.init();
			scrollIntoView({ behavior: 'instant' });
		}
	}, []);

	return (
		<CmsPageProviderCore
			ref={ref}
			{...props}
			skeleton={<CmsPageSkeleton>{props.skeleton}</CmsPageSkeleton>}>
			{props.children}
		</CmsPageProviderCore>
	);
};
